﻿import React from 'react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8', 
    lg: 'w-12 h-12'
  }

  const dotSizes = {
    sm: 'w-1 h-1',
    md: 'w-1.5 h-1.5',
    lg: 'w-2 h-2'
  }

  return (
    <div className={`flex items-center justify-center space-x-1 ${className}`}>
      {/* Três pontos com animação de bounce escalonada */}
      <div 
        className={`${dotSizes[size]} bg-primary-500 dark:bg-primary-400 rounded-full animate-bounce`}
        style={{ animationDelay: '0ms' }}
      ></div>
      <div 
        className={`${dotSizes[size]} bg-primary-500 dark:bg-primary-400 rounded-full animate-bounce`}
        style={{ animationDelay: '150ms' }}
      ></div>
      <div 
        className={`${dotSizes[size]} bg-primary-500 dark:bg-primary-400 rounded-full animate-bounce`}
        style={{ animationDelay: '300ms' }}
      ></div>
    </div>
  )
}

export default LoadingSpinner
